import { render, staticRenderFns } from "./LandingImage.vue?vue&type=template&id=32f3e52c&scoped=true"
import script from "./LandingImage.vue?vue&type=script&lang=js"
export * from "./LandingImage.vue?vue&type=script&lang=js"
import style0 from "./LandingImage.vue?vue&type=style&index=0&id=32f3e52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3e52c",
  null
  
)

export default component.exports